import m from "./../../../dist/es2015/themes/Dataviz.js";
export const am5themes_Dataviz = m;